import { InfoOutline } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';
import Row from 'components/Layout/Row';
import { PropsWithChildren } from 'react';

type Props = {
  tooltip?: string;
  text: string;
};

const SwitchRow: React.FC<PropsWithChildren<Props>> = ({
  children,
  tooltip,
  text,
}) => {
  return (
    <Row centered fullWidth justify="space-between">
      <Row spacing="xxs" centered>
        <Typography variant="h6">{text}</Typography>
        {tooltip ? (
          <Tooltip title={tooltip}>
            <InfoOutline fontSize="inherit" />
          </Tooltip>
        ) : null}
      </Row>
      {children}
    </Row>
  );
};

export default SwitchRow;
